import { MouseEventHandler } from 'react';

type IconProps = { className?: string; onClick: MouseEventHandler<SVGSVGElement> };

export const InfoIcon = ({ className, onClick }: IconProps) => (
  <svg
    onClick={onClick}
    className={className}
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#F4F4F4" />
    <path
      d="M8.564 12.572v-1.493h-1.32v1.493h1.32Zm-.013-2.484c0-.978.333-1.392.948-1.893.68-.552 1.358-1.28 1.358-2.37 0-1.368-1.025-2.396-2.793-2.396-1.793 0-2.908 1.103-2.92 2.797H6.5c.039-1.041.538-1.643 1.525-1.643.922 0 1.448.489 1.448 1.266 0 .866-.603 1.367-1.192 1.869-.743.64-.96 1.091-.96 2.37h1.23Z"
      fill="#4F4F4F"
    />
  </svg>
);
